<template>
  <section id="calendar-sheet__section--meta">
    <div
      id="calendar-sheet__date"
      class="text-black inline-block text-base font-normal tracking-[1.5px] mt-[1vh] py-[2px] px-[16px] uppercase"
    >
      {{ routedDate.toLocaleDateString("nl-NL", { weekday: "long" }) }},
      {{
        routedDate.toLocaleDateString("nl-NL", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })
      }}
    </div>

    <h1
      id="calendar-sheet__title"
      class="inline-block font-bree font-[900] text-[25px] tracking-[-0.6px] text-center"
      :key="routedDay.title"
    >
      {{ routedDay.title }}
    </h1>

    <h2
      id="calendar-sheet__theme"
      class="solid inline-block text-[21px] pt-[2px] px-[16px] pb-[4px] tracking-[.5px]"
      :key="routedDay.theme"
    >
      thema: {{ routedDay.theme }}
    </h2>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalendarSheetMeta",
  computed: {
    ...mapGetters(["routedDay"]),

    routedDate() {
      if (!this.routedDay) {
        return null;
      }
      return new Date(this.routedDay.date);
    },
  },
};
</script>

<style lang="css">
.school-level-onderbouw #calendar-sheet__date {
  @apply text-green;
}

.school-level-midden-bovenbouw #calendar-sheet__date {
  @apply text-purple;
}

.school-level-onderbouw #calendar-sheet__title {
  @apply text-green;
}

.school-level-midden-bovenbouw #calendar-sheet__title {
  @apply text-purple;
}

.school-level-onderbouw #calendar-sheet__theme {
  @apply text-green;
}

.school-level-midden-bovenbouw #calendar-sheet__theme {
  @apply text-purple;
}
</style>
